import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface TenantConfig {
  id: string
  name: string
  subdomain: string
  baseDomain: string
  fullDomain: string // subdomain.baseDomain
  redmineBaseUrl: string
  isActive: boolean
  // SECURITY: Database fields removed - all DB operations proxied through backend
}

interface TenantState {
  currentTenant: TenantConfig | null
  setTenant: (tenant: TenantConfig | null) => void
  clearTenant: () => void
  fetchTenantFromCookie: () => Promise<void>
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      currentTenant: null,

      setTenant: (tenant) => set({ currentTenant: tenant }),

      clearTenant: () => set({ currentTenant: null }),

      fetchTenantFromCookie: async () => {
        if (typeof window === 'undefined') return

        try {
          // Check if tenant context cookie exists (set by middleware)
          const cookies = document.cookie.split(';')
          const tenantCookie = cookies.find(c => c.trim().startsWith('tenant-context='))

          if (!tenantCookie) {
            set({ currentTenant: null })
            return
          }

          // Extract cookie value and decode it
          const cookieValue = tenantCookie.split('=').slice(1).join('=').trim()
          const tenantData = JSON.parse(decodeURIComponent(cookieValue))

          // Map the backend tenant response to TenantConfig
          const tenantConfig: TenantConfig = {
            id: tenantData.id,
            name: tenantData.name,
            subdomain: tenantData.subdomain,
            baseDomain: tenantData.baseDomain || 'oxigen.local',
            fullDomain: tenantData.fullDomain || `${tenantData.subdomain}.${tenantData.baseDomain}`,
            redmineBaseUrl: tenantData.redmineBaseUrl,
            isActive: tenantData.isActive
          }

          set({ currentTenant: tenantConfig })
        } catch (error) {
          console.error('Failed to fetch tenant from cookie:', error)
          set({ currentTenant: null })
        }
      },
    }),
    {
      name: 'tenant-storage',
    }
  )
)
